import type { ReactNode } from "react";
import { Table, type TableProps } from "antd";
import type { ColumnsType } from "antd/es/table";

export type CampaignTableProps<T> = TableProps<T> & {
  columns: ColumnsType<T>;
  data: T[];
  loading?: boolean;
  rowKey?: TableProps<T>["rowKey"];
  customPagination?: ReactNode;
};

const CampaignTable = <T extends object>({
  columns,
  data,
  loading = false,
  rowKey = "id",
  customPagination,
  className,
  ...rest
}: CampaignTableProps<T>) => (
  <div className="campaign-table-wrapper">
    <Table<T>
      rowKey={rowKey}
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={false}
      bordered={false}
      scroll={{ x: 480 }}
      className={`campaign-table ${className || ""}`}
      footer={customPagination ? () => customPagination : undefined}
      {...rest}
    />
  </div>
);

export default CampaignTable;
